// Reports a DEAD END the user was just shown — a failure the server handled and
// therefore never logged as an error.
//
// Why this exists: the import wizard re-renders its form with an error message
// and logs nothing at all. The user sees "import failed"; monitoring sees a
// successful 200. That gap is invisible from both ends, and it is the same gap
// that made the 2026-09-12 KROS incident take a log dig to find.
//
// This is DIAGNOSTICS, not analytics. The distinction is deliberate and load
// bearing: we send an event when we showed somebody a failure, never to measure
// what people do. Product funnels would be behavioural tracking and need a
// consent story this does not have — see the GTM consent-gate finding. Keep the
// vocabulary closed and the payloads free of anything a user typed.
//
// Better Stack's own gating applies on top: custom events respect sampling and
// the workspace's auto-capture toggles.

// `diag.` marks the namespace as ours and keeps these separable from anything a
// future product-analytics stream might send through the same tag.
const NAMESPACE = "diag."

/**
 * @param {string} name  closed-vocabulary event name, e.g. "import.error_shown"
 * @param {Object} [data] closed-vocabulary values only — enums, slugs, counts.
 *                        NEVER user-entered text, a document number, or an
 *                        error message: those can carry customer data.
 */
export function trackDiagnostic(name, data = {}) {
  if (typeof window.betterstack !== "function") return
  if (!name) return

  try {
    window.betterstack("track", `${NAMESPACE}${name}`, data)
  } catch {
    // Telemetry must never be the reason a page breaks. There is nowhere useful
    // to report a failure of the thing that does the reporting.
  }
}
